import type { HealthScoreSegment, HealthScoreUrgency } from './types'

export const HEALTH_SCORE_ENDPOINT = 'office/providers/get-health-score'
export const HEALTH_SCORE_WIDGET_ID = 'health-score-widget'

export const SEGMENT_LABEL: Record<HealthScoreSegment, string> = {
    red: 'Red',
    orange: 'Orange',
    green: 'Green',
}

export const URGENCY_LABEL: Record<HealthScoreUrgency, string> = {
    now: 'Contact now',
    soon: 'Contact soon',
    monitor: 'Monitor',
}

export const SEGMENT_BADGE_CLASSES: Record<HealthScoreSegment, string> = {
    red: 'bg-red-100 !text-red-700',
    orange: 'bg-amber-100 !text-amber-700',
    green: 'bg-green-100 !text-green-700',
}

export const URGENCY_TAG_CLASSES: Record<HealthScoreUrgency, string> = {
    now: 'bg-red-50 text-red-700 border-red-200',
    soon: 'bg-amber-50 text-amber-800 border-amber-200',
    monitor: 'bg-neutral-50 text-neutral-700 border-neutral-200',
}

export const SIGNAL_ICON_CLASSES: Record<HealthScoreSegment, string> = {
    red: 'bg-red-100 text-red-700',
    orange: 'bg-amber-100 text-amber-700',
    green: 'bg-green-100 text-green-700',
}

export const SIGNAL_ICON_LABEL: Record<HealthScoreSegment, string> = {
    red: '!',
    orange: '~',
    green: '✓',
}

export const CHURN_DRIVER_LABEL: Record<string, string> = {
    'paused-quality': 'Paused: quality',
    'paused-busy': 'Paused: too busy',
    'paused-personal': 'Paused: personal',
    'supply-starved': 'Supply-starved',
    'low-conversion': 'Low conversion',
    disengagement: 'Disengagement',
    'lead-quality': 'Lead quality',
    'declining-performance': 'Declining',
    other: 'Other',
}

export const formatChurnDriver = (driver: string): string =>
    CHURN_DRIVER_LABEL[driver] || driver.replaceAll('-', ' ').replace(/^\w/, (c) => c.toUpperCase())
